export default __webpack_public_path__ + "privacy_policy_de.pdf";